// src/components/molecules/LeadStatusDefinitions/LeadStatusDefinitions.tsx
import React from "react";

const leadStatuses = [
  {
    key: "hot",
    chipClass: "chip--status-hot",
    title: "High Intent",
    description: "Immediate action required. High intent.",
  },
  {
    key: "warm",
    chipClass: "chip--status-warm",
    title: "Medium Intent",
    description: "Engage within 24 hours.",
  },
  {
    key: "interested",
    chipClass: "chip--status-interested",
    title: "Low Intent",
    description: "Requires further nurturing.",
  },
  {
    key: "rejected",
    chipClass: "chip--status-rejected",
    title: "Rejected - POOR",
    description: "Does not meet qualification criteria.",
  },
  {
    key: "progress",
    chipClass: "chip--status-progress",
    title: "In progress",
    description: "Pending AI categorization.",
  },
  {
    key: "systemerror",
    chipClass: "chip--status-systemerror",
    title: "System error",
    description: "Issue in lead or system error.",
  },
];

const LeadStatusDefinitions: React.FC = () => {
  return (
    <div className="lead-status-definitions">
      <p className="lead-status-definitions__title">LEAD STATUS DEFINITIONS</p>

      <div className="lead-status-definitions__list">
        {leadStatuses.map((status) => (
          <div
            key={status.key}
            className={`lead-status-definitions__item lead-status-definitions__item--${status.key}`}
          >
            <div className="lead-status-definitions__icon">
              <span className={`chip chip--soft ${status.chipClass}`}></span>
            </div>

            <div className="lead-status-definitions__content">
              <strong>{status.title}</strong>
              <span>{status.description}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeadStatusDefinitions;
